import api from "app/api";

export interface UserChangePasswordFormItem {
  password: string;
}

export function getUserChangePasswordService(user_id: any) {
  return api.getService<UserChangePasswordFormItem, UserChangePasswordFormItem>(
    `users/password-change/${user_id}`,
    {
      itemExporter: item => ({ User: item }),
    }
  );
}
